import { State } from 'modules';

export const isAnyPopoverCurrentlyOpen = (state: State): boolean =>
  state.ui.popovers.length !== 0;

export const isPopoverShown = (state: State, name: symbol | string): boolean =>
  state.ui.popovers.includes(name);



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/popovers.ts